//created by sudip
const capabilities = [
    "ERP",
    "CRM",
    "Healthcare",
    "Retail",
    "Education",
    "Logistics",
];

export function CapabilityChips() {

    return (
        <div className="flex flex-wrap gap-3 px-7 py-4">

            {capabilities.map((item) => (

                <span
                    key={item}
                    className="rounded-full border border-slate-200 bg-slate-50 px-2 py-2 text-sm font-semibold text-slate-700"
                >
                    {item}
                </span>
            ))}

        </div>
    );
}